import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./config";

/**
 * Save newsletter subscription to Firestore
 * @param {Object} subscription - Subscription data
 * @param {string} subscription.email - Subscriber email
 * @param {string} [subscription.source] - Source identifier (e.g., footer form)
 * @returns {Promise<string>} - Document ID of the saved subscription
 */
export const saveNewsletterSubscription = async (subscription) => {
  try {
    const newsletterCollection = collection(db, "newsletter_subscribers");

    const docRef = await addDoc(newsletterCollection, {
      email: subscription.email,
      source: subscription.source || "newsletter_form",
      timestamp: serverTimestamp(),
      status: "active",
    });

    console.log("Newsletter subscription saved with ID: ", docRef.id);
    return docRef.id;
  } catch (error) {
    console.error("Error saving newsletter subscription: ", error);
    throw new Error("Failed to subscribe. Please try again.");
  }
};

